import Cookies from "js-cookie";

const TokenKey = "token";

// export function getToken() {
//   return Cookies.get(TokenKey);
// }

// export function setToken(token) {
//   return Cookies.set(TokenKey, token);
// }

// export function removeToken() {
//   Cookies.remove("token");
//   return Cookies.remove(TokenKey);
// }

// 获取长期缓存
function getStorage(name) {
  return localStorage.getItem(name);
}
// 设置长期缓存
function setStorage(name, data) {
  return localStorage.setItem(name, data);
}
// 清除长期缓存
function clearStorage() {
  return localStorage.clear();
}
// 获取会话缓存
function getSessionStorage(name) {
  return sessionStorage.getItem(name);
}
// 设置会话缓存
function setSessionStorage(name, data) {
  sessionStorage.setItem(name, data);
}
// 清除会话缓存
function clearSessionStorage() {
  sessionStorage.clear();
}
// 删除缓存
function removeSessionStorage(name) {
  sessionStorage.removeItem(name);
}

export {
  getSessionStorage,
  setSessionStorage,
  clearSessionStorage,
  clearStorage,
  setStorage,
  getStorage,
  removeSessionStorage,
};
